module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-12-3495d7e0c9582353171992ee190fe8be.png";